import Grid from "@mui/material/Grid";
import { BtnSMGroupStyle } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import YSCheckBox from "../../uikit/YSCheckBox";

export default function TimeList(props: any) {
  return (
    <Grid
      container
      item
      xs={12}
      spacing={1}
      alignItems="center"
      justifyContent="flex-start"
    >
      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeMorning"
          label={"Morning"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeMorning", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeMorning", "");
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeNoon"
          label={"Noon"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeNoon", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeNoon", "");
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeEvening"
          label={"Evening"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeEvening", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeEvening", "");
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeNight"
          label={"Night"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeNight", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeNight", "");
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeBedTime"
          label={"Bedtime"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeBedTime", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeBedTime", "");
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeBeforeMeals"
          label={"Before meals"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeBeforeMeals", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeBeforeMeals", "");
            }
          }}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeAfterMeals"
          label={"After meals"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeAfterMeals", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeAfterMeals", "");
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <YSCheckBox
          name="sigTimeBeforeBed"
          label={"Before Bed"}
          onChange={(e: any) => {
            if (e.target.checked) {
              props.formProps.setFieldValue("sigTimeBeforeBed", "ON");
            } else {
              props.formProps.setFieldValue("sigTimeBeforeBed", "");
            }
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <BtnSMGroupStyle style={{ textAlign: "center", margin: 10 }}>
          <YSButton
            size="large"
            className=""
            color="primary"
            dataTestId="submitBtn"
            variant="contained"
            disabled={false}
            type="button"
            children={"Submit"}
            onClick={props.handleHidePopupClick}
          />
          <YSButton
            size="large"
            className=""
            color="secondary"
            dataTestId="submitBtn"
            variant="outlined"
            disabled={false}
            type="reset"
            children={"Reset"}
            onClick={() => {
              props.formProps.setFieldValue("sigTimeMorning", "");
              props.formProps.setFieldValue("sigTimeNoon", "");
              props.formProps.setFieldValue("sigTimeEvening", "");
              props.formProps.setFieldValue("sigTimeNight", "");
              props.formProps.setFieldValue("sigTimeBedTime", "");
              props.formProps.setFieldValue("sigTimeBeforeMeals", "");
              props.formProps.setFieldValue("sigTimeAfterMeals", "");
              props.formProps.setFieldValue("sigTimeBeforeBed", "");
            }}
          />{" "}
        </BtnSMGroupStyle>
      </Grid>
    </Grid>
  );
}
